import { useState } from "react";
import Icon from "@/components/feature/Icon";
import { usePublicRows } from "@/hooks/usePublicContent";
import { faqItems } from "@/mocks/membershipData";
import type { DbFaq } from "@/types/database";

const FALLBACK_FAQS: DbFaq[] = faqItems.map((f, i) => ({
  id: -(i + 1),
  page: "membership",
  question: f.q,
  answer: f.a,
  sort_order: i + 1,
  is_active: true,
  created_at: "",
  updated_at: "",
}));

/** 會員專區的常見問題（後台「常見問題」→ 顯示頁面＝會員專區）。沒有資料時不顯示。 */
export default function MembershipFaq({ className = "" }: { className?: string }) {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const { rows: faqs } = usePublicRows<DbFaq>("faqs", FALLBACK_FAQS, { refine: (q) => q.eq("page", "membership") });

  if (faqs.length === 0) return null;

  return (
    <div className={className}>
      <h3 className="text-lg font-semibold text-navy-950 mb-6">常見問題</h3>
      <div className="space-y-3">
        {faqs.map((item, idx) => (
          <div key={item.id} className="border border-silver-200 rounded-2xl overflow-hidden">
            <button
              type="button"
              onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
              aria-expanded={openFaq === idx}
              className="w-full flex items-center justify-between p-4 text-left hover:bg-silver-50 transition-colors"
            >
              <span className="text-sm font-medium text-navy-950 pr-4">{item.question}</span>
              <Icon
                className={`ri-arrow-down-s-line text-silver-400 shrink-0 transition-transform ${openFaq === idx ? "rotate-180" : ""}`}
              />
            </button>
            {openFaq === idx && (
              <div className="px-4 pb-4 text-sm text-silver-500 leading-relaxed whitespace-pre-line">{item.answer}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
